/**
 * @file 設定ファイル
 * @namespace ddv2.library
 */
/**
 * @module configure
 */

/**
 * ルート定義
 */
const ROUTE_SETTING = [
  {
    path: '/componentsamples',
    name: 'Home',
    component: () => import('../components/HelloWorld.vue'),
    meta: { allowAnonymous: true }
  },
  {
    path: '/',
    name: 'Login',
    component: () => import('../views/D2COMD0010.vue'),
    meta: { allowAnonymous: true }
  },
  {
    path: '/dashboard',
    name: 'DashBoard',
    component: () => import('../views/D2COMD0020.vue')
  },
  {
    path: '/DDBoard',
    name: 'DDBoard',
    component: () => import('../views/D2COMD0200.vue')
  },
  {
    path: '/DDCalendar',
    name: 'DDCalendar',
    component: () => import('../views/D2COMD0040.vue')
  },
  {
    path: '/password/edit/:id',
    name: 'PasswordEdit',
    component: () => import('../views/D2COMD0050.vue'),
    meta: { allowAnonymous: true }
  },
  /*
  {
    path: '/loginInfoInquiry',
    name: 'LoginInfoInquiry',
    component: () => import('../views/D2COMD0060.vue'),
    meta: { allowAnonymous: true }
  },
  */
  {
    path: '/riyokiyaku/:id',
    name: 'RiyoKiyaku',
    component: () => import('../views/D2COMD0070.vue'),
    meta: { allowAnonymous: true }
  },
  {
    path: '/orc/juchu/list',
    name: 'juchu-list',
    component: () => import('../views/ORC/juchu/JuchuList.vue')
  },
  {
    path: '/com/juchukensaku',
    name: 'com-juchukensaku',
    component: () => import('../views/test/JuchuKensaku.vue')
  },
  {
    path: '/com/hacchukensaku',
    name: 'com-hacchukensaku',
    component: () => import('../views/test/JuchuKensaku.vue')
  },
  {
    path: '/mst/torihikisaki/list',
    name: 'mst-torihikisaki-list',
    component: () => import('../views/MST/D2MSTD0010.vue')
  },
  {
    path: '/mst/torihikisaki/edit/:id',
    name: 'mst-torihikisaki-edit',
    component: () => import('../views/MST/D2MSTD0020.vue')
  },
  {
    path: '/mst/tokuisaki/edit/:id',
    name: 'mst-tokuisaki-edit',
    component: () => import('../views/MST/D2MSTD0021.vue')
  },
  {
    path: '/mst/hacchusaki/edit/:id',
    name: 'mst-hacchusaki-edit',
    component: () => import('../views/MST/D2MSTD0022.vue')
  },
  {
    path: '/mst/shiiresaki/edit/:id',
    name: 'mst-shiiresaki-edit',
    component: () => import('../views/MST/D2MSTD0023.vue')
  },
  {
    path: '/mst/torihikisaki/listedit',
    name: 'mst-torihikisaki-listedit',
    component: () => import('../views/MST/D2MSTD1110.vue')
  },
  {
    path: '/mst/sharyo/list',
    name: 'mst-sharyo-list',
    component: () => import('../views/MST/D2MSTD0030.vue')
  },
  {
    path: '/mst/sharyo/edit/:id',
    name: 'mst-sharyo-edit',
    component: () => import('../views/MST/D2MSTD0040.vue')
  },
  {
    path: '/mst/sharyo/listedit',
    name: 'mst-sharyo-listedit',
    component: () => import('../views/MST/D2MSTD1120.vue')
  },
  {
    path: '/mst/hinmei/list',
    name: 'mst-hinmei-list',
    component: () => import('../views/MST/D2MSTD0050.vue')
  },
  {
    path: '/mst/hinmei/edit/:id',
    name: 'mst-hinmei-edit',
    component: () => import('../views/MST/D2MSTD0060.vue')
  },
  {
    path: '/mst/hacchakuchi/list',
    name: 'mst-hacchakuchi-list',
    component: () => import('../views/MST/D2MSTD0070.vue')
  },
  {
    path: '/mst/hacchakuchi/edit/:id',
    name: 'mst-hacchakuchi-edit',
    component: () => import('../views/MST/D2MSTD0080.vue')
  },
  {
    path: '/mst/shubetsu/list',
    name: 'mst-shubetsu-list',
    component: () => import('../views/MST/D2MSTD0130.vue')
  },
  {
    path: '/mst/shubetsu/edit/:id/:msysksid',
    name: 'mst-shubetsu-edit',
    component: () => import('../views/MST/D2MSTD0140.vue')
  },
  {
    path: '/mst/kubun/list',
    name: 'mst-kubun-list',
    component: () => import('../views/MST/D2MSTD0150.vue')
  },
  {
    path: '/mst/kubun/edit/:id',
    name: 'mst-kubun-edit',
    component: () => import('../views/MST/D2MSTD0160.vue')
  },
  {
    path: '/mst/eigyosho/list',
    name: 'mst-eigyosho-list',
    component: () => import('../views/MST/D2MSTD0170.vue')
  },
  {
    path: '/mst/eigyosho/edit/:id',
    name: 'mst-eigyosho-edit',
    component: () => import('../views/MST/D2MSTD0180.vue')
  },
  {
    path: '/mst/jinin/list',
    name: 'mst-jinin-list',
    component: () => import('../views/MST/D2MSTD0190.vue')
  },
  {
    path: '/mst/jinin/listedit',
    name: 'mst-jinin-listedit',
    component: () => import('../views/MST/D2MSTD1100.vue')
  },
  {
    path: '/mst/jinin/edit/:id',
    name: 'mst-jinin-edit',
    component: () => import('../views/MST/D2MSTD0200.vue')
  },
  {
    path: '/mst/kihonjoho/edit',
    name: 'mst-kihonjoho-edit',
    component: () => import('../views/MST/D2MSTD0280.vue')
  },
  {
    path: '/mst/kouza/list',
    name: 'mst-jisha-ginko-koza-list',
    component: () => import('../views/MST/D2MSTD0290.vue')
  },
  {
    path: '/mst/kouza/edit/:id',
    name: 'mst-jisha-ginko-koza-edit',
    component: () => import('../views/MST/D2MSTD0300.vue')
  },
  {
    path: '/mst/kengen/list',
    name: 'mst-kengen-list',
    component: () => import('../views/MST/D2MSTD0310.vue')
  },
  {
    path: '/mst/kengen/edit/:id',
    name: 'mst-kengen-edit',
    component: () => import('../views/MST/D2MSTD0320.vue')
  },
  {
    path: '/mst/nenryotanka/edit/',
    name: 'mst-nenryotanka-edit',
    component: () => import('../views/MST/D2MSTD0330.vue')
  },
  {
    path: '/mst/hiwaywaribiki/edit',
    name: 'mst-hiwaywaribiki-edit',
    component: () => import('../views/MST/D2MSTD0340.vue')
  },
  {
    path: '/mst/teikei/list',
    name: 'mst-teikei-list',
    component: () => import('../views/MST/D2MSTD0350.vue')
  },
  {
    path: '/mst/course/custom/list',
    name: 'mst-course-custom-list',
    component: () => import('../views/MST/D2MSTD0351.vue')
  },
  {
    path: '/mst/teikei/edit/:id',
    name: 'mst-teikei-edit',
    component: () => import('../views/MST/D2MSTD0360.vue')
  },
  {
    path: '/mst/course/custom/edit/:id',
    name: 'mst-course-custom-edit',
    component: () => import('../views/MST/D2MSTD0370.vue')
  },
  {
    path: '/mst/haishahyo/listedit',
    name: 'mst-haishahyo-listedit',
    component: () => import('../views/MST/D2MSTD0380.vue')
  },
  {
    path: '/mst/etcriyou/list',
    name: 'mst-etcriyou-list',
    component: () => import('../views/MST/D2MSTD0390.vue')
  },
  {
    path: '/mst/etcriyou/edit',
    name: 'mst-etcriyou-edit',
    component: () => import('../views/MST/D2MSTD0400.vue')
  },
  {
    path: '/mst/hacchakuchitanka/listm',
    name: 'mst-hacchakuchitanka-listm',
    component: () => import('../views/MST/D2MSTD0410.vue')
  },
  {
    path: '/mst/hacchakuchitanka/list',
    name: 'mst-hacchakuchitanka-list',
    component: () => import('../views/MST/D2MSTD0411.vue')
  },
  {
    path: '/mst/hacchakuchitanka/editm/:id',
    name: 'mst-hacchakuchitanka-editm',
    component: () => import('../views/MST/D2MSTD0420.vue')
  },
  {
    path: '/mst/hacchakuchitanka/edit/:id',
    name: 'mst-hacchakuchitanka-edit',
    component: () => import('../views/MST/D2MSTD0421.vue')
  },
  {
    path: '/mst/hacchakuchikyori/list',
    name: 'mst-hacchakuchikyori-list',
    component: () => import('../views/MST/D2MSTD0430.vue')
  },
  {
    path: '/mst/hacchakuchikyori/edit/:id',
    name: 'mst-hacchakuchikyori-edit',
    component: () => import('../views/MST/D2MSTD0440.vue')
  },
  {
    path: '/mst/course/package/list',
    name: 'mst-course-package-list',
    component: () => import('../views/MST/D2MSTD0450.vue')
  },
  {
    path: '/mst/course/package/edit/:id',
    name: 'mst-course-package-edit',
    component: () => import('../views/MST/D2MSTD0460.vue')
  },
  {
    path: '/mst/course/list',
    name: 'mst-course-list',
    component: () => import('../views/MST/D2MSTD0451.vue')
  },
  {
    path: '/mst/course/edit/:id',
    name: 'mst-course-edit',
    component: () => import('../views/MST/D2MSTD0461.vue')
  },
  {
    path: '/msys/oshirase/listedit',
    name: 'msys-oshirase-listedit',
    component: () => import('../views/MST/D2MSTD0470.vue')
  },
  {
    path: '/mst/nenpi/listedit',
    name: 'mst-nenpi-listedit',
    component: () => import('../views/MST/D2MSTD0480.vue')
  },
  {
    path: '/mst/kyuyutanka/management',
    name: 'mst-kyuyutanka-management',
    component: () => import('../views/MST/D2MSTD0490.vue')
  },
  {
    path: '/mst/menu/maintenance',
    name: 'mst-menu-maintenance',
    component: () => import('../views/MST/D2MSTD1000.vue')
  },
  {
    path: '/mst/shubetsu/listedit',
    name: 'mst-shubetsu-listedit',
    component: () => import('../views/MST/D2MSTD1010.vue')
  },
  {
    path: '/orc/juchukeiyaku/list',
    name: 'orc-juchukeiyaku-list',
    component: () => import('../views/ORC/D2ORCD0010.vue')
  },
  {
    path: '/orc/juchukeiyaku/edit/:id',
    name: 'orc-juchukeiyaku-edit',
    component: () => import('../views/ORC/D2ORCD0020.vue')
  },
  {
    path: '/orc/himoduke/edit/',
    name: 'orc-himoduke-edit',
    component: () => import('../views/ORC/D2ORCD0040.vue')
  },
  {
    path: '/rco/juchu/list',
    name: 'rco-juchu-list',
    component: () => import('../views/RCO/D2RCOD0010.vue')
  },
  {
    path: '/RCO/juchu/editm/:id',
    name: 'rco-juchu-editm',
    component: () => import('../views/RCO/D2RCOD0020.vue')
  },
  {
    path: '/RCO/juchu/edit/:id',
    name: 'rco-juchu-edit',
    component: () => import('../views/RCO/D2RCOD0050.vue')
  },
  {
    path: '/rco/miseikyujuchukingaku/list',
    name: 'rco-miseikyujuchukingaku-list',
    component: () => import('../views/RCO/D2RCOD0060.vue')
  },
  /*
  {
    path: '/rco/miseikyujuchukingaku/list',
    name: 'rco-miseikyujuchukingaku-list',
    component: () => import('../views/RCO/D2RCOD0070.vue')
  },
  */
  {
    path: '/rco/unsohikiuke/list',
    name: 'rco-unsohikiuke-list',
    component: () => import('../views/RCO/D2RCOD0080.vue')
  },
  {
    path: '/rco/unsohikiuke/edit/:id',
    name: 'rco-unsohikiuke-edit',
    component: () => import('../views/RCO/D2RCOD0090.vue')
  },
  {
    path: '/oic/hacchukeiyaku/list',
    name: 'oic-hacchukeiyaku-list',
    component: () => import('../views/OIC/D2OICD0010.vue')
  },
  {
    path: '/oic/hacchukeiyaku/edit/:id',
    name: 'oic-hacchukeiyaku-edit',
    component: () => import('../views/OIC/D2OICD0020.vue')
  },
  {
    path: '/oic/hacchuhimoduke/edit/',
    name: 'oic-hacchuhimoduke-edit',
    component: () => import('../views/OIC/D2OICD0050.vue')
  },
  {
    path: '/plo/hacchu/list',
    name: 'plo-hacchu-list',
    component: () => import('../views/PLO/D2PLOD0010.vue')
  },
  {
    path: '/PLO/hacchu/editm/:id',
    name: 'plo-hacchu-editm',
    component: () => import('../views/PLO/D2PLOD0020.vue')
  },
  {
    path: '/plo/mishiharaihacchukingaku/list',
    name: 'plo-mishiharaihacchukingaku-list',
    component: () => import('../views/PLO/D2PLOD0060.vue')
  },
  {
    path: '/PLO/hacchu/edit/:id',
    name: 'plo-hacchu-edit',
    component: () => import('../views/PLO/D2PLOD0050.vue')
  },
  {
    path: '/plo/unsoirai/list',
    name: 'plo-unsoirai-list',
    component: () => import('../views/PLO/D2PLOD0080.vue')
  },
  {
    path: '/plo/unsoirai/edit/:id',
    name: 'plo-unsoirai-edit',
    component: () => import('../views/PLO/D2PLOD0090.vue')
  },
  {
    path: '/plm/haisha/manage/',
    name: 'haisya-manage',
    component: () => import('../views/PLM/D2PLMD0010.vue')
  },
  {
    path: '/plm/haisha/plan/',
    name: 'haisha-plan',
    component: () => import('../views/PLM/D2PLMD0020.vue')
  },
  {
    path: '/plm/sagyomeisai/list/',
    name: 'plm-sagyomeisai-list',
    component: () => import('../views/PLM/D2PLMD0030.vue')
  },
  {
    path: '/plm/sagyomeisai/edit/:id',
    name: 'plm-sagyomeisai-edit',
    component: () => import('../views/PLM/D2PLMD0040.vue')
  },
  {
    path: '/plm/haisha/output',
    name: 'plm-haisha-output',
    component: () => import('../views/PLM/D2PLMD0090.vue')
  },
  {
    path: '/plm/haisha/listedit',
    name: 'plm-haisha-listedit',
    component: () => import('../views/PLM/D2PLMD1010.vue')
  },
  {
    path: '/plm/haisha/calendar',
    name: 'plm-haisha-calendar',
    component: () => import('../views/PLM/D2PLMD9010.vue')
  },
  {
    path: '/plm/tenkobo/listedit',
    name: 'plm-tenkobo-listedit',
    component: () => import('../views/PLM/D2PLMD3010.vue')
  },
  {
    path: '/prm/haishameisai/list',
    name: 'prm-haishameisai-list',
    component: () => import('../views/PRM/D2PRMD0010.vue')
  },
  {
    path: '/prm/nippo/list',
    name: 'prm-nippo-list',
    component: () => import('../views/PRM/D2PRMD0011.vue')
  },
  {
    path: '/prm/haishameisai/custom_ishibashi/list',
    name: 'prm-haishameisai-list_custom_ishibashi',
    component: () => import('../views/PRM/D2PRMD0010001.vue')
  },
  {
    path: '/prm/haishameisai/edit/:id+',
    name: 'prm-haishameisai-edit',
    component: () => import('../views/PRM/D2PRMD0020.vue')
  },
  {
    path: '/prm/haishameisai/edit_custom_ishibashi/:id+',
    name: 'prm-haishameisai-edit_custom_ishibashi',
    component: () => import('../views/PRM/D2PRMD0020001.vue')
  },
  {
    path: '/prm/nippo/list',
    name: 'prm-nippo-list',
    component: () => import('../views/PRM/D2PRMD0011.vue')
  },
  {
    path: '/prm/nippo/edit/:id+',
    name: 'prm-nippo-edit',
    component: () => import('../views/PRM/D2PRMD0021.vue')
  },
  {
    path: '/prm/haishameisai/listedit/',
    name: 'prm-haishameisai-listedit',
    component: () => import('../views/PRM/D2PRMD0030.vue')
  },
  {
    path: '/prm/nippo/easyedit/:id+',
    name: 'prm-nippo-easyedit',
    component: () => import('../views/PRM/D2PRMD0040.vue')
  },
  {
    path: '/prm/digitako',
    name: 'prm-dezitako',
    component: () => import('../views/PRM/D2PRMD0800.vue')
  },
  {
    path: '/prm/etc',
    name: 'prm-etc',
    component: () => import('../views/PRM/D2PRMD0810.vue')
  },
  {
    path: '/prm/jitsuunsokanribo/listedit',
    name: 'prm-jitsuunsokanribo-listedit',
    component: () => import('../views/PRM/D2PRMD3000.vue')
  },
  {
    path: '/fue/nenryo/listEdit',
    name: 'fue-nenryo-listEdit',
    component: () => import('../views/FUE/D2FUED0010.vue')
  },
  {
    path: '/fue/nenryo/listEditXls',
    name: 'fue-nenryo-listEditXls',
    component: () => import('../views/FUE/D2FUED0011.vue')
  },
  {
    path: '/fue/nenpi/list',
    name: 'fue-nenpi-list',
    component: () => import('../views/FUE/D2FUED0030.vue')
  },
  {
    path: '/fue/nenpi/kanri',
    name: 'fue-nenpi-kanri',
    component: () => import('../views/FUE/D2FUED0040.vue')
  },
  {
    path: '/fue/nenpi/board',
    name: 'fue-nenpi-board',
    component: () => import('../views/FUE/D2FUED0050.vue')
  },
  {
    path: '/fue/sharyobetsunenpi/listEdit',
    name: 'fue-sharyobetsunenpi-listEdit',
    component: () => import('../views/FUE/D2FUED0060.vue')
  },
  {
    path: '/bil/seikyu/list',
    name: 'bil-seikyu-list',
    component: () => import('../views/BIL/D2BILD0010.vue')
  },
  {
    path: '/bil/seikyumeisai/list',
    name: 'bil-seikyumeisai-list',
    component: () => import('../views/BIL/D2BILD0020.vue')
  },
  {
    path: '/bil/seikyumeisai/listedit',
    name: 'bil-seikyumeisai-listedit',
    component: () => import('../views/BIL/D2BILD1020.vue')
  },
  {
    path: '/bil/seikyuzandakachosei/edit/:id',
    name: 'bil-seikyu-zandaka-chosei-edit',
    component: () => import('../views/BIL/D2BILD0040.vue')
  },
  {
    path: '/bil/seikyuzandakachosei/list',
    name: 'bil-seikyu-zandaka-chosei-list',
    component: () => import('../views/BIL/D2BILD0050.vue')
  },
  {
    path: '/dep/nyukin/list',
    name: 'dep-nyukin-list',
    component: () => import('../views/DEP/D2DEPD0010.vue')
  },
  {
    path: '/dep/nyukin/edit/:id',
    name: 'dep-nyukin-edit',
    component: () => import('../views/DEP/D2DEPD0020.vue')
  },
  {
    path: '/dep/nyukinTorikomi/list',
    name: 'dep-nyukintorikomi-list',
    component: () => import('../views/DEP/D2DEPD0030.vue')
  },
  {
    path: '/dep/nyukintorikomimeisai/edit/:id',
    name: 'dep-nyukintorikomimeisai-edit',
    component: () => import('../views/DEP/D2DEPD0040.vue')
  },
  {
    path: '/dep/nyukinTorikomi/Edit',
    name: 'dep-nyukintorikomi-edit',
    component: () => import('../views/DEP/D2DEPD0050.vue')
  },
  {
    path: '/bcl/urikake/listedit/:seikyusakiId?',
    name: 'bcl-urikake-listedit',
    component: () => import('../views/BCL/D2BCLD0120.vue')
  },
  {
    path: '/bcl/urikakezan/list',
    name: 'bcl-urikakezan-list',
    component: () => import('../views/BCL/D2BCLD0110.vue')
  },
  {
    path: '/bcl/seikyukeshikomi/list',
    name: 'bcl-seikyukeshikomi-list',
    component: () => import('../views/BCL/D2BCLD0010.vue')
  },
  {
    path: '/bcl/seikyukeshikomi/edit/:id',
    name: 'bcl-seikyukeshikomi-edit',
    component: () => import('../views/BCL/D2BCLD0020.vue')
  },
  {
    path: '/bcl/nyukinmikeshikomi/list/',
    name: 'bcl-nyukinmikeshikomi-list',
    component: () => import('../views/BCL/D2BCLD0030.vue')
  },
  {
    path: '/bcl/minyukin/list/',
    name: 'bcl-minyukin-list',
    component: () => import('../views/BCL/D2BCLD0040.vue')
  },
  {
    path: '/bcl/urikakezandaka/list/',
    name: 'bcl-urikakezandaka-list',
    component: () => import('../views/BCL/D2BCLD0050.vue')
  },
  {
    path: '/pay/shiharai/list/',
    name: 'pay-shiharai-list',
    component: () => import('../views/PAY/D2PAYD0010.vue')
  },
  {
    path: '/pay/shiharaimeisai/list',
    name: 'pay-shiharaimeisai-list',
    component: () => import('../views/PAY/D2PAYD0020.vue')
  },
  {
    path: '/pay/shiharaizandakachosei/edit/:id',
    name: 'pay-shiharai-zandaka-chosei-edit',
    component: () => import('../views/PAY/D2PAYD0040.vue')
  },
  {
    path: '/pay/shiharaizandakachosei/list',
    name: 'pay-shiharai-zandaka-chosei-list',
    component: () => import('../views/PAY/D2PAYD0050.vue')
  },
  {
    path: '/pay/yoshameisai/list/',
    name: 'pay-yoshameisai-list',
    component: () => import('../views/PAY/D2PAYD0110.vue')
  },
  {
    path: '/pay/yoshameisaidetail/listedit',
    name: 'pay-yoshameisaidetail-listedit',
    component: () => import('../views/PAY/D2PAYD0120.vue')
  },
  {
    path: '/bzm/kessan/getsuji',
    name: 'bzm-kessan-getsuji',
    component: () => import('../views/BZM/D2BZMD0010.vue')
  },
  {
    path: '/bzm/nikkeihyo/list/',
    name: 'bzm-nikkeihyo-list',
    component: () => import('../views/BZM/D2BZMD0020.vue')
  },
  {
    path: '/bzm/torihikisakibetsu/output',
    name: 'bzm-torihikisakibetsu-output',
    component: () => import('../views/BZM/D2BZMD0030.vue')
  },
  {
    path: '/bzm/shushihyo/month',
    name: 'bzm-shushihyo-month',
    component: () => import('../views/BZM/D2BZMD0130.vue')
  },
  {
    path: '/bzm/shushihyo/daily',
    name: 'bzm-shushihyo-daily',
    component: () => import('../views/BZM/D2BZMD0140.vue')
  },
  {
    path: '/bzm/sharyobetsu/jisseki/output',
    name: 'bzm-sharyobetsu-jisseki-output',
    component: () => import('../views/BZM/D2BZMD1010.vue')
  },
  {
    path: '/bzm/jomuinbetsu/jisseki/output',
    name: 'bzm-jomuinbetsu-jisseki-output',
    component: () => import('../views/BZM/D2BZMD2010.vue')
  },
  {
    path: '/bzm/eigyosho/output',
    name: 'bzm-eigyosho-output',
    component: () => import('../views/BZM/D2BZMD3010.vue')
  },
  {
    path: '/bzm/kamotsujidosha/output',
    name: 'bzm-kamotsujidosha-output',
    component: () => import('../views/BZM/D2BZMD3110.vue')
  },
  /*
  {
    path: '/wdl/kaikakezan/list',
    name: 'wdl-kaikakezan-list',
    component: () => import('../views/WDL/D2WDLD0120.vue')
  },
  */
  {
    path: '/utl/import/list',
    name: 'mst-import-list',
    component: () => import('../views/UTL/D2UTLD0010.vue')
  },
  {
    path: '/utl/import/edit/:id/:edit',
    name: 'mst-import-edit',
    component: () => import('../views/UTL/D2UTLD0020.vue')
  },
  {
    path: '/utl/export/list',
    name: 'mst-export-list',
    component: () => import('../views/UTL/D2UTLD0030.vue')
  },
  // 東邦興産用定義
  {
    path: '/rco/TohoKamotsu',
    name: 'rco-toho-kamotsu',
    component: () => import('../views/RCO/THRCOD0010.vue')
  },
  {
    path: '/prm/TohoNippo',
    name: 'prm-toho-nippo',
    component: () => import('../views/PRM/THPRMD0010.vue')
  },
  {
    path: '/prm/dijitakotorikomi',
    name: 'prm-dijitako-torikomi',
    component: () => import('../views/PRM/THPRMD0020.vue')
  },
  {
    path: '/toho/ninushibetsuseikyukingakukanri/list',
    name: 'toho-ninushibetsuseikyukingakukanri-list',
    component: () => import('../views/BZM/THBZMD0010.vue')
  },
  {
    path: '/toho/yoshabetshiharaikingakukanri/list',
    name: 'toho-yoshabetsushiharaikingakukanri-list',
    component: () => import('../views/BZM/THBZMD0020.vue')
  },
  {
    path: '/toho/ninushiseikyushukei/list',
    name: 'ninushiseikyushukei-list',
    component: () => import('../views/BZM/THBZMD0030.vue')
  },
  {
    path: '/toho/ninushibetsuuriageshukei/list/',
    name: 'toho-ninushibetsu-uriage-shukei-list',
    component: () => import('../views/BZM/THBZMD0040.vue')
  },
  {
    path: '/toho/kamotsunouriage/list',
    name: 'toho-kamotsu-no-uriage-list',
    component: () => import('../views/BZM/THBZMD0050.vue')
  },
  {
    path: '/toho/nippouuriage/list',
    name: 'toho-nippouuriage-list',
    component: () => import('../views/BZM/THBZMD0060.vue')
  },
  {
    path: '/toho/dataimport/list',
    name: 'toho-data-import-list',
    component: () => import('../views/UTL/THUTLP0010.vue')
  },
  {
    path: '/toho/dataimport/exec/:id/:edit',
    name: 'toho-data-import-exec',
    component: () => import('../views/UTL/THUTLP0020.vue')
  },
  // 202204新規追加
  {
    path: '/prm/kintaijisseki/list',
    name: 'prm-kintaijisseki-list',
    component: () => import('../views/PRM/D2PRMD1010.vue')
  },
  {
    path: '/prm/kintaijisseki/edit/:id',
    name: 'prm-kintaijisseki-edit',
    component: () => import('../views/PRM/D2PRMD1020.vue')
  },
  {
    path: '/prm/ippankeihi/list/',
    name: 'prm-ippankeihi-list',
    component: () => import('../views/PRM/D2PRMD2110.vue')
  },
  {
    path: '/prm/ippankeihi/edit/:id',
    name: 'prm-ippankeihi-edit',
    component: () => import('../views/PRM/D2PRMD2120.vue')
  },
  {
    path: '/prm/sharyokeihi/list/',
    name: 'prm-sharyokeihi-list',
    component: () => import('../views/PRM/D2PRMD2010.vue')
  },
  {
    path: '/prm/sharyokeihi/edit/:id',
    name: 'prm-sharyokeihi-edit',
    component: () => import('../views/PRM/D2PRMD2020.vue')
  },
  {
    path: '/prm/sharyokeihi/listedit/',
    name: 'prm-sharyokeihi-listedit',
    component: () => import('../views/PRM/D2PRMD2030.vue')
  },
  {
    path: '/prm/unkojisseki/list/',
    name: 'prm-unkojisseki-list',
    component: () => import('../views/PRM/D2PRMD0500.vue')
  },
  {
    path: '/prm/unkojisseki/edit/:id',
    name: 'prm-unkojisseki-edit',
    component: () => import('../views/PRM/D2PRMD0510.vue')
  },
  {
    path: '/prm/shuttaikin/manage/',
    name: 'prm-shuttaikin-manage',
    component: () => import('../views/PRM/D2PRMD5000.vue')
  },
  // OTM用定義
  {
    path: '/rco/otm/deliveryledger/',
    name: 'rco-otm-delivery-ledger',
    component: () => import('../views_otm/RCO/OTRCOD0010.vue')
  },
  {
    path: '/rco/otm/schedule/',
    name: 'rco-otm-schedule',
    component: () => import('../views_otm/RCO/OTRCOD0100.vue')
  },
  {
    path: '/rco/otm/deliveryboard/',
    name: 'rco-otm-delivery-board',
    component: () => import('../views_otm/RCO/OTRCOD0200.vue')
  },
  {
    path: '/rco/otm/dashboard/',
    name: 'rco-otm-dashboard',
    component: () => import('../views_otm/RCO/OTRCOD0300.vue')
  },
  // 泉州用定義
  {
    path: '/prm/ssv/kinmukanri/',
    name: 'prm-ssv-kinmukanri',
    component: () => import('../views_ssv/PRM/SSPRMD0200.vue')
  },
  {
    path: '/prm/ssv/kinmukanriX/',
    name: 'prm-ssv-kinmukanriX',
    component: () => import('../views_ssv/PRM/SSPRMD0210.vue')
  },
  // 九州センコー
  {
    path: '/plm/ksl/haisha/schedule/',
    name: 'plm-ksl-haisha-schedule',
    component: () => import('../views_ksl/PLM/KSPLMD0100.vue')
  },
  // Mock
  {
    path: '/mock/mockrco0010/',
    name: 'mock-rco-0010',
    component: () => import('../views/MOCK/MOCKRCOD0010.vue')
  },
  {
    path: '/mock/mockrco0020/',
    name: 'mock-rco-0020',
    component: () => import('../views/MOCK/MOCKRCOD0020.vue')
  },
  // antz用定義
  {
    path: '/antz/prm/nippo/list',
    name: 'prm-nippo-list-antz',
    component: () => import('../views_antz/PRM/D2PRMD0011.vue')
  },
  {
    path: '/antz/prm/nippo/edit/:id+',
    name: 'prm-nippo-edit-antz',
    component: () => import('../views_antz/PRM/D2PRMD0021.vue')
  },
  {
    path: '/antz/prm/nippo/easyedit/:id+',
    name: 'prm-nippo-easyedit-antz',
    component: () => import('../views_antz/PRM/D2PRMD0040.vue')
  },
  {
    path: '/antz/mst/course/package/list',
    name: 'mst-course-package-list-antz',
    component: () => import('../views_antz/MST/D2MSTD0450.vue')
  },
  {
    path: '/antz/mst/course/package/edit/:id',
    name: 'mst-course-package-edit-antz',
    component: () => import('../views_antz/MST/D2MSTD0460.vue')
  },
  {
    path: '/antz/bzm/torihikisakibetsu/output',
    name: 'bzm-torihikisakibetsu-output-antz',
    component: () => import('../views_antz/BZM/D2BZMD0030.vue')
  },
  // 滋賀自工用定義
  {
    path: '/sgj/mst/course/package/list',
    name: 'mst-course-package-list-sgj',
    component: () => import('../views_sgj/MST/D2MSTD0450.vue')
  },
  {
    path: '/sgj/mst/course/package/edit/:id',
    name: 'mst-course-package-edit-sgj',
    component: () => import('../views_sgj/MST/D2MSTD0460.vue')
  },
  {
    path: '/sgj/prm/nippo/list',
    name: 'prm-nippo-list-sgj',
    component: () => import('../views_sgj/PRM/D2PRMD0011.vue')
  },
  {
    path: '/sgj/prm/nippo/list',
    name: 'prm-nippo-list-sgj-sp',
    component: () => import('../views_sgj/PRM/D2PRMD0012.vue')
  },
  {
    path: '/sgj/prm/nippo/easyedit/:id+',
    name: 'prm-nippo-easyedit-sgj',
    component: () => import('../views_sgj/PRM/D2PRMD0040.vue')
  },
  {
    path: '/sgj/prm/nippo/easyedit/:id+',
    name: 'prm-nippo-easyedit-sgj-sp',
    component: () => import('../views_sgj/PRM/D2PRMD0041.vue')
  },
  // 花巻運送用定義
  {
    path: '/hnu/prm/nippo/list',
    name: 'prm-nippo-list-hnu',
    component: () => import('../views_hnu/PRM/D2PRMD0011.vue')
  },
  {
    path: '/hnu/prm/nippo/edit/:id+',
    name: 'prm-nippo-edit-hnu',
    component: () => import('../views_hnu/PRM/D2PRMD0021.vue')
  },
  {
    path: '/hnu/prm/nippo/easyedit/:id+',
    name: 'prm-nippo-easyedit-hnu',
    component: () => import('../views_hnu/PRM/D2PRMD0040.vue')
  },
  {
    path: '/hnu/mst/course/package/list',
    name: 'mst-course-package-list-hnu',
    component: () => import('../views_hnu/MST/D2MSTD0450.vue')
  },
  {
    path: '/hnu/mst/course/package/edit/:id',
    name: 'mst-course-package-edit-hnu',
    component: () => import('../views_hnu/MST/D2MSTD0460.vue')
  },
  // 株式会社日伸用定義
  {
    path: '/nsn/plm/haisha/listedit',
    name: 'plm-haisha-listedit-nsn',
    component: () => import('../views_nsn/PLM/D2PLMD1010.vue')
  },
  // アズレック有限会社用定義
  {
    path: '/azc/plm/haisha/listedit',
    name: 'plm-haisha-listedit-azc',
    component: () => import('../views_azc/PLM/D2PLMD1010.vue')
  },
  // オーナミ
  {
    path: '/o73/prm/jisseki/edit/:id',
    name: 'prm-jisseki-edit',
    component: () => import('../views_o73/prm/O73PRMD0020.vue')
  },
  // 桜花運輸株式会社用定義
  {
    path: '/oka/plm/haisha/listedit',
    name: 'plm-haisha-listedit-oka',
    component: () => import('../views_oka/PLM/D2PLMD1010.vue')
  },
  // 鍛代商事用定義
  {
    path: '/kti/plm/haisha/listedit',
    name: 'plm-haisha-listedit-kti',
    component: () => import('../views_kti/PLM/D2PLMD1010.vue')
  },
  // アサガミ物流用定義
  {
    path: '/asg/mst/course/package/list',
    name: 'mst-course-package-list-asg',
    component: () => import('../views_asg/MST/D2MSTD0450.vue')
  },
  {
    path: '/asg/mst/course/package/edit/:id',
    name: 'mst-course-package-edit-asg',
    component: () => import('../views_asg/MST/D2MSTD0460.vue')
  },
  // 群馬グリーン用定義
  {
    path: '/ggr/plm/haisha/listedit',
    name: 'plm-haisha-listedit-ggr',
    component: () => import('../views_ggr/PLM/D2PLMD1010.vue')
  },
  // 光陽テクノサービス用定義
  {
    path: '/kts/plm/haisha/listedit',
    name: 'plm-haisha-listedit-kts',
    component: () => import('../views_kts/PLM/D2PLMD1010.vue')
  },
  // 光陽テクノサービス用定義
  {
    path: '/kts/bil/seikyu/list',
    name: 'bil-seikyu-list-kts',
    component: () => import('../views_kts/BIL/D2BILD0010.vue')
  },
  {
    path: '/kts/bil/seikyumeisai/listedit',
    name: 'bil-seikyumeisai-listedit-kts',
    component: () => import('../views_kts/BIL/D2BILD1020.vue')
  },
  {
    path: '/kts/prm/nippo/list',
    name: 'prm-nippo-list-kts',
    component: () => import('../views_kts/PRM/D2PRMD0011.vue')
  },
  {
    path: '/kts/prm/nippo/edit/:id+',
    name: 'prm-nippo-edit-kts',
    component: () => import('../views_kts/PRM/D2PRMD0021.vue')
  },
  {
    path: '/kts/prm/nippo/easyedit/:id+',
    name: 'prm-nippo-easyedit-kts',
    component: () => import('../views_kts/PRM/D2PRMD0040.vue')
  },
  // 幸栄トランスポート用定義
  {
    path: '/ket/mst/course/package/list',
    name: 'mst-course-package-list-ket',
    component: () => import('../views_ket/MST/D2MSTD0450.vue')
  },
  {
    path: '/ket/mst/course/package/edit/:id',
    name: 'mst-course-package-edit-ket',
    component: () => import('../views_ket/MST/D2MSTD0460.vue')
  },
  // マーキュリー用定義
  {
    path: '/mrc/plm/haisha/listedit',
    name: 'plm-haisha-listedit-mrc',
    component: () => import('../views_mrc/PLM/D2PLMD1010.vue')
  },
  {
    path: '/mrc/plo/unsoirai/list',
    name: 'plo-unsoirai-list-mrc',
    component: () => import('../views_mrc/PLO/D2PLOD0080.vue')
  },
  {
    path: '/mrc/plo/unsoirai/edit/:id',
    name: 'plo-unsoirai-edit-mrc',
    component: () => import('../views_mrc/PLO/D2PLOD0090.vue')
  },
  // ドリームロード株式会社用定義
  {
    path: '/dld/plm/haisha/listedit',
    name: 'plm-haisha-listedit-dld',
    component: () => import('../views_dld/PLM/D2PLMD1010.vue')
  }
]

export default {
  ROUTE_SETTING
}
